"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Certiblok Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.8.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SyncfolderApi = exports.SyncfolderApiFactory = exports.SyncfolderApiFp = exports.SyncfolderApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * SyncfolderApi - axios parameter creator
 * @export
 */
const SyncfolderApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get sync folder download url
         * @param {'windows' | 'mac'} platform
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSyncFolderDownloadUrl: (platform, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'platform' is not null or undefined
            (0, common_1.assertParamExists)('getSyncFolderDownloadUrl', 'platform', platform);
            const localVarPath = `/sync-folder/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication headerAuth required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "authorization", configuration);
            if (platform !== undefined) {
                localVarQueryParameter['platform'] = platform;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.SyncfolderApiAxiosParamCreator = SyncfolderApiAxiosParamCreator;
/**
 * SyncfolderApi - functional programming interface
 * @export
 */
const SyncfolderApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.SyncfolderApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Get sync folder download url
         * @param {'windows' | 'mac'} platform
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSyncFolderDownloadUrl(platform, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSyncFolderDownloadUrl(platform, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.SyncfolderApiFp = SyncfolderApiFp;
/**
 * SyncfolderApi - factory interface
 * @export
 */
const SyncfolderApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.SyncfolderApiFp)(configuration);
    return {
        /**
         *
         * @summary Get sync folder download url
         * @param {'windows' | 'mac'} platform
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSyncFolderDownloadUrl(platform, options) {
            return localVarFp.getSyncFolderDownloadUrl(platform, options).then((request) => request(axios, basePath));
        },
    };
};
exports.SyncfolderApiFactory = SyncfolderApiFactory;
/**
 * SyncfolderApi - object-oriented interface
 * @export
 * @class SyncfolderApi
 * @extends {BaseAPI}
 */
class SyncfolderApi extends base_1.BaseAPI {
    /**
     *
     * @summary Get sync folder download url
     * @param {'windows' | 'mac'} platform
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SyncfolderApi
     */
    getSyncFolderDownloadUrl(platform, options) {
        return (0, exports.SyncfolderApiFp)(this.configuration).getSyncFolderDownloadUrl(platform, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.SyncfolderApi = SyncfolderApi;
